module.exports = __webpack_public_path__ + "static/media/video-02.c99663b4.mp4";